export default "__VITE_ASSET__Wf$PPrAC__"